import DapDSCardImage from './card-image.component'

export * from './card-image.component'
export default DapDSCardImage

DapDSCardImage.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-card-image': DapDSCardImage
  }
}
